import { ValidationSchema } from 'validation-schema-library';
import getAzureDomain from 'infrastructure/email/config/emailConfiguration';

const domainName = getAzureDomain();
const emailPattern = `^.+@((disabled)?\\d+\\.)?${domainName}$`;

const personalInfoValidationSchema: ValidationSchema = {
  nameLocal: {
    type: 'object',
    properties: {
      firstName: {
        type: 'string',
        required: {
          value: true,
          when: [
            {
              $_PERMISSIONS: {
                ct: 'UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO',
              },
            },
            {
              $_IS_CREATE_REQUEST: {
                eq: true,
              },
            },
          ],
        },
      },
      lastName: {
        type: 'string',
        required: true,
      },
      middleName: {
        type: 'string',
      },
    },
  },
  nameEn: {
    type: 'object',
    _divisible: false,
    properties: {
      firstName: {
        type: 'string',
        required: true,
        regex: {
          value: '^[a-zA-Z-]+$',
          message: 'Only latin characters and hyphen',
        },
      },
      lastName: {
        type: 'string',
        required: true,
        regex: {
          value: '^[a-zA-Z-]+$',
          message: 'Only latin characters and hyphen',
        },
      },
    },
  },
  workingEmail: {
    type: 'string',
    email: true,
    regex: {
      value: `${emailPattern}`,
      message: `Email must be within ${domainName} domain`,
    },
    required: {
      value: true,
      when: [
        {
          $_PERMISSIONS: {
            ct: 'UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO',
          },
        },
        {
          $_IS_CREATE_REQUEST: {
            eq: true,
          },
        },
      ],
    },
  },
  gender: {
    type: 'enum',
    required: {
      value: true,
      when: [
        {
          $_PERMISSIONS: {
            ct: 'UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO',
          },
        },
        {
          $_IS_CREATE_REQUEST: {
            eq: true,
          },
        },
      ],
    },
  },
  employeeType: {
    type: 'enum',
    required: {
      value: true,
      when: [
        {
          $_PERMISSIONS: {
            ct: 'UPDATE_EMPLOYEE_MAIN_HR_INFORMATION',
          },
        },
        {
          $_IS_CREATE_REQUEST: {
            eq: true,
          },
        },
      ],
    },
  },
  extendedInformation: {
    type: 'object',
    properties: {
      hrInformation: {
        type: 'object',
        _divisible: false,
        properties: {
          workplaceLocation: {
            type: 'string',
            maxSize: 255,
            required: true,
          },
          roomNumber: {
            type: 'string',
            maxSize: 8,
          },
          deskLocation: {
            type: 'string',
            maxSize: 48,
          },
          accessCardId: {
            type: 'string',
            maxSize: 12,
          },
        },
      },
      photosIds: {
        type: 'array',
        required: {
          value: true,
        },
      },
      dateOfBirth: {
        type: {
          value: 'date',
          message: 'Please, enter a valid date',
        },
        required: {
          value: true,
          when: [
            {
              $_PERMISSIONS: {
                ct: 'UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO',
              },
            },
            {
              $_IS_CREATE_REQUEST: {
                eq: true,
              },
            },
          ],
        },
        maxDate: {
          value: '$NOW',
          message: 'Must be in the past',
        },
      },
      requisitesInformation: {
        type: 'object',
        required: {
          value: true,
          when: {
            $employeeType: {
              eq: 'CONTRACTOR',
            },
          },
        },
        _divisible: false,
        properties: {
          requisites: {
            type: 'string',
            maxSize: '60000',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO',
                  },
                  $employeeType: {
                    eq: 'CONTRACTOR',
                  },
                },
              ],
            },
          },
          scansIds: {
            type: 'array',
            maxSize: '5',
          },
        },
      },
    },
  },
};

const getPersonalInfoValidationSchema = () => Promise.resolve(personalInfoValidationSchema);

export default getPersonalInfoValidationSchema;
